"use client";

import axios from "axios";
import { useEffect } from "react";
import CustomLoader from "./loader";
import { addMobiguestlinkLogs } from "../services/logs";

const Feedback = () => {

  const detailPayload = (cutomername, customerid, feedback) => {
    let details = {
      object: "whatsapp_business_account",
      entry: [
        {
          id: "",
          changes: [
            {
              value: {
                messaging_product: "whatsapp",
                metadata: {
                  display_phone_number: "",
                  phone_number_id: "",
                },
                contacts: [
                  {
                    profile: {
                      name: cutomername,
                    },
                    wa_id: customerid,
                  },
                ],
                messages: [
                  {
                    context: {
                      from: "",
                      id: "",
                    },
                    from: customerid,
                    id: "",
                    timestamp: Math.floor(Date.now() / 1000),
                    type: "button",
                    button: {
                      payload: feedback,
                      text: feedback,
                    },
                  },
                ],
              },
              field: "messages",
            },
          ],
        },
      ],
    };
    return details;
  };

  const loadChat = async () => {
    const chatJson = await axios.get(
      "https://theconnexions.co.in/constants/chatviewer.json"
    );
    const chatData = chatJson.data;
    return chatData;
  };

  const sendRequestPayload = async (
    placeid,
    businessid,
    customerid,
    businessname,
    customername,
    feedbackRating
  ) => {
    let reqmsg = {
      context: "",
      businessid: businessid,
      businesschainid: "",
      businesslist: [],
      cid: customerid,
      customername: customername,
      businessname: businessname,
      messagesource: "wabawebhook",
    };

    const chatData = await loadChat();
    const feedback = chatData[`feedbackrating_${feedbackRating}`];
    const details = detailPayload(customername, customerid, feedback);
    reqmsg["body"] = JSON.stringify(details);
    try {
      axios.post(
        "https://us-central1-connexions-85d01.cloudfunctions.net/wabamessagingservice",
        reqmsg
      );
      window.location.href = `https://search.google.com/local/writereview?placeid=${placeid}`;
    } catch (e) {
      window.location.href = `https://search.google.com/local/writereview?placeid=${placeid}`;
    }
  };

  useEffect(() => {
    const queryParams = window.location.search;
    const queryData = new URLSearchParams(queryParams);
    let feedbackRating = queryData.get("feedbackrating");
    const placeid = queryData.get("placeid");
    const businessid = queryData.get("businessid");
    const customerid = queryData.get("customerid");
    const businessname = queryData.get("businessname");
    const customername = queryData.get("customername");

    const fullUrl = window.location.href;
    const urlPayload = {
      url: fullUrl,
      businessid: businessid || "",
      type: "feedback"
    }
    addMobiguestlinkLogs(urlPayload)

    if (feedbackRating > 3 && feedbackRating <= 5) {
      sendRequestPayload(
        placeid,
        businessid,
        customerid,
        businessname,
        customername,
        feedbackRating
      );
    } else {
    }
  }, []);

  return (
    <div>
      <CustomLoader />
    </div>
  );
};

export default Feedback;
